import { messageStore, messageActions } from 'modules/notifications/store/messageStore';
import { socketStore, socketActions } from 'modules/notifications/store/socketStore';
import { // schedulerStatusNoticeStore, 
  schedulerStatusNoticeActions, 
} from 'modules/scheduler/store/schedulerStatusNoticeStore';
import { // schedulerStore, 
  schedulerActions, 
} from 'modules/scheduler/store/schedulerStore';

import { // schedulerStore, 
  permissionActions, 
} from 'modules/permissions/store/permissionStore';

export { officeStore } from 'modules/partners/store/officeStore'; // Устарел
export { partnerOfficeStore } from 'modules/partners/store/offices/partnerOfficeStore'; // надо использовать вместо officeStore
export { carmenStore } from 'modules/orders/store/carmen/carmenStore';
export { invoicesStore } from 'modules/orders/store/invoices/invoicesStore';
export { invoiceDocumentsStore } from 'modules/orders/store/documents/documentStore';
export { partnerLegalStore } from 'modules/partners/store/partnerLegalStore';
export { partnerStore } from 'modules/partners/store/partnerStore';
export { clientNotificationsStore } from 'modules/clients/store/notificationsStore';
export { positionsStore } from 'modules/prices/store/positionStore';
export { priceListStore } from 'modules/prices/store/priceListStore';
export { vehicleStore } from 'modules/vehicles/store/vehicleStore';
export { partnerInsurancesStore } from 'modules/partners/store/insurances/partnerInsurancesStore';
export { insurancesCompaniesStore } from 'modules/insurances/store/insurancesCompaniesStore';
export { servicePositionsStore } from 'modules/prices/store/servicePositionStore';
export { clientStore } from 'modules/clients/store/clientStore';
export { clientActivityStore } from 'modules/clients/store/activityStore';
export { priceListRegionsStore } from 'modules/prices/store/priceListRegionStore';
export { priceListItemsStore } from 'modules/prices/store/priceListItemsStore';
export { partnerClientsStore } from 'modules/partners/store/clients/partnerClientsStore';
export { reportStore } from 'modules/reports/store/reportStore';
export { userStore } from 'modules/users/store/userStore';
export { contractStore } from 'modules/partners/contracts/store/contractStore';
export { reconciliationStore } from 'modules/reconciliations/store/reconciliationStore';
export { evacuationStore } from 'modules/orders/store/evacuation/evacuationStore';
export { priceListServiceOfficeStore } from 'modules/prices/store/priceListServiceOfficeStore';
export { cardReferenceStore } from 'modules/service-cards/store/cardReferenceStore';
export { schedulerReferenceStore } from 'modules/scheduler/store/schedulerReferenceStore';
export { schedulerStore } from 'modules/scheduler/store/schedulerStore';
export { schedulerHalfYearStore } from 'modules/scheduler/store/schedulerHalfYearStore';
export { priceCalculateStore } from 'modules/scheduler/store/priceCalculateStore';
export { tireStorageStore } from 'modules/orders/store/tire-storage/tireStorageStore';
export { tireStorageV2Store } from 'modules/references/tyres/store/tireStorageV2Store'; // с ноября 2024 новую концепцию утвердили с поддержкой 1С
export { partnerOrderStore } from 'modules/orders/store/partner/partnerOrderStore';
export { printingStore } from 'modules/orders/store/printing/printingStore';
export { orderStore } from 'modules/orders/store/orders/orderStore'; // доп. хранилище заявок на mobx
export { promoReferenceStore } from 'modules/promos/store/promoReferenceStore';
export { promoStore } from 'modules/promos/store/promoStore';
export { partnerTemplateStore } from 'modules/partners/store/templates/partnerTemplateStore';
export { cronTaskStore } from 'modules/config/store/cronTaskStore';
export { feedbackStore } from 'modules/feedback/store/feedbackStore';
export { executorsStore } from 'modules/orders/store/executors/executorsStore';
export { seoReferenceStore } from 'modules/seo/store/seoReferenceStore';
export { statusReferenceStore } from 'modules/statuses/store/statusReferenceStore';
export { checklistStore } from 'modules/orders/store/checklist/checklistStore';
export { serviceStore } from 'modules/permissions/store/serviceStore';
export { servicesStore } from 'modules/permissions/store/servicesStore';
export { permissionStore } from 'modules/permissions/store/permissionStore';
export { projectStore } from 'modules/permissions/store/projectStore';
export { partnerServicesStore } from 'modules/partners/store/services/partnerServicesStore';
export { orderOfferStore } from 'modules/orders/store/orderOffers/orderOfferStore';
export { communicationStore } from 'modules/orders/store/communication/communicationStore';
export { photoStore } from 'modules/orders/store/photo/photoStore';
export { tireDefectsStore } from 'modules/orders/store/tireDefects/tireDefectsStore';
export { partnerCarParkStore } from 'modules/partners/store/carpark/partnerCarParkStore';
export { partnerDivisionStore } from 'modules/partners/store/divisions/partnerDivisionStore';
export { insuranceDocStore } from 'modules/orders/store/insuranceDocs/insuranceDocStore';
export { messageStore } from 'modules/notifications/store/messageStore';
export { socketStore } from 'modules/notifications/store/socketStore';
export { schedulerStatusNoticeStore } from 'modules/scheduler/store/schedulerStatusNoticeStore';
export { informerStore } from 'modules/prices/store/informerStore';
export { positionGroupsStore } from 'modules/prices/store/positionGroupsStore';
export { tBankReportStore } from 'modules/reports/tbank/store/tBankReportStore';
export { universalReferenceStore } from 'modules/universal-reference/store/universalReferenceStore';

//  далее новый синтаксис - для тестов, удобно или нет ?
export const stores = {
  messageStore,
  socketStore,
  // schedulerStatusNoticeStore,
  //schedulerStore,
};

export const actions = {
  messageActions,
  socketActions,
  schedulerStatusNoticeActions,
  schedulerActions,
  permissionActions,
};

// Экспорты типов (для удобства)
export { SchedulerStatusNoticeStore } from 'modules/scheduler/store/schedulerStatusNoticeStore';
export { SchedulerStore } from 'modules/scheduler/store/schedulerStore';
export { PermissionStore } from 'modules/permissions/store/permissionStore';

export type RootStore = typeof stores;
